<template>
  <v-card class="mt-2" outlined>
    <v-container fluid>
      <v-row class="pa-3">
        <v-col class="d-flex justify-start" cols="7">
          <h2>{{ $t('title_ClubSettings') }}</h2>
        </v-col>
      </v-row>
      <v-divider class="my-5"/>
      <v-row class="pa-3">
        <v-col cols="3">
          <h3>{{ $t('basics.title') }} <v-icon class="mt-n2 ml-1" small>fa-home</v-icon></h3>
          <p class="mb-0">{{ $t('basics.description') }}</p>
        </v-col>
        <v-col cols="9">
          <v-row>
            <v-col cols="8">
              <v-form class="d-flex" v-model="nameValidation">
                <v-text-field v-model="name" :hint="$t('basics.nameHint')" :label="$t('basics.nameLabel')" counter="25"
                              :rules="nameRules" outlined/>
                <v-icon :disabled="!nameValidation" class="ml-2 mt-n5 icon" color="primary"
                        v-if="name !== previousName" @click="modifyName" small>fa-check</v-icon>
              </v-form>
            </v-col>
            <v-col cols="4">
              <v-form class="d-flex" v-model="colorValidation">
                <v-icon class="mr-2 mt-n7" :style="`color: #${color} !important;`" large>fa-circle</v-icon>
                <v-text-field class="color-class" v-model="color" :hint="$t('basics.colorHint')" readonly
                              :label="$t('basics.colorLabel')" @click="openColorPicker" :rules="colorRules" outlined/>
                <v-icon :disabled="!colorValidation" class="ml-2 mt-n5 icon" color="primary" v-if="color !== previousColor" @click="modifyColor" small>fa-check</v-icon>
              </v-form>
            </v-col>
            <v-col cols="12">
              <v-form class="d-flex" v-model="descriptionValidation">
                <v-text-field v-model="description" :hint="$t('basics.descriptionHint')" :label="$t('basics.descriptionLabel')"
                              counter="100" :rules="descriptionRules" outlined/>
                <v-icon :disabled="!descriptionValidation" class="ml-2 mt-n5 icon" color="primary"
                        v-if="description !== previousDescription" @click="modifyDescription" small>fa-check</v-icon>
              </v-form>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-divider class="my-5"/>
      <v-row class="pa-3">
        <v-col cols="3">
          <h3>{{ $t('plan.title') }} <v-icon class="mt-n2 ml-1" small>fa-gem</v-icon></h3>
          <p class="mb-0">{{ $t('plan.description') }}</p>
        </v-col>
        <v-col cols="9">
          <v-card style="border-color:#ababab;" max-width="45%" class="pa-5" outlined>
            <h4>{{ plan.name }}</h4>
            <p class="mt-1 mb-3">{{ $t('plan.capacity', { threshold: plan.threshold }) }}</p>
            <v-btn v-if="plan.name == 'Free' || plan.name == 'Gratis' || plan.name == 'Swiset custom'" class="button-plans" v-on="plan.name == 'Free' || plan.name == 'Gratis' ? { click: goToPlans } : { click: goToSupport }" outlined>
              <v-icon class="mr-2" x-small>fa-fire</v-icon>
              {{ plan.name == 'Free' || plan.name == 'Gratis' ? $t('plansBtn') : $t('plansBtnContactSupport') }}</v-btn>
          </v-card>
        </v-col>
      </v-row>
    </v-container>

    <!-- Overlay to pick color !-->
    <v-overlay :dark="false" v-model="overlayColor">
      <ColorPicker :initial-color="color" @saveColor="saveColor" @closeWindow="overlayColor = false"/>
    </v-overlay>
  </v-card>
</template>

<script>
import ColorPicker from "@/components/ColorPicker";
import Repository from '../../../repositories/club';
import { mapMutations } from 'vuex';

export default {
  name: "ClubSettings",
  components: {ColorPicker},
  data() {
    return {
      // Basics
      name: '',
      previousName: '',
      description: '',
      previousDescription: '',
      overlayColor: false,
      color: '',
      previousColor: '',
      nameValidation: false,
      nameRules: [
        n => !!n || this.$t('validations.nameMandatory'),
        n => (n && n.length <= 25) || this.$t('validations.nameCount'),
      ],
      descriptionValidation: false,
      descriptionRules: [
        d => !!d || this.$t('validations.descriptionMandatory'),
        d => (d && d.length <= 100) || this.$t('validations.descriptionCount'),
      ],
      colorValidation: false,
      colorRules: [
        c => !!c || this.$t('validations.colorMandatory'),
        c => (c && c.length === 6) || this.$t('validations.colorCount'),
      ],

      // Plan
      plan: {
        name: this.$t('planNames.free'),
        threshold: 10,
        plan: '',
      },
    };
  },
  mounted() {
    this.setDefaults();
    this.getPlan();
  },
  methods: {
    setDefaults() {
      this.name = this.$store.state.clubMember.club.name;
      this.previousName = this.name;
      this.description = this.$store.state.clubMember.club.description;
      this.previousDescription = this.description;
      this.color = String(this.$store.state.clubMember.club.primaryColor).toUpperCase();
      this.previousColor = this.color;
    },
    getPlan() {
      let clubPackage = this.$store.state.clubMember.club.clubPackage;
      if (clubPackage !== null) {
        this.plan.name = clubPackage.name;
        this.plan.threshold = this.$store.state.clubMember.club.threshold;
      }
    },
    openColorPicker() {
      this.overlayColor = true;
    },
    saveColor(selectedColor) {
      this.color = String(selectedColor).replace('#', '');
      this.overlayColor = false;
    },
    ...mapMutations(['setClubMember']),
    modifyName() {
      let editingData = {
        clubId: this.$store.state.clubMember.club.id,
        name: this.name,
      };

      Repository.modifyClubName(editingData).then((response) => {
        if(response.status < 400) {
          Repository.getClubMember(this.$store.state.clubMember.id).then((secondResponse) => {
            alert(this.$t('notifications.successfulNameEdit'));
            this.setClubMember(secondResponse.data);
            this.previousName = this.name;
          });
        }
      });
    },
    ...mapMutations(['setClubMember']),
    modifyDescription() {
      let editingData = {
        clubId: this.$store.state.clubMember.club.id,
        description: this.description,
      };

      Repository.modifyClubDescription(editingData).then((response) => {
        if(response.status < 400) {
          Repository.getClubMember(this.$store.state.clubMember.id).then((secondResponse) => {
            alert(this.$t('notifications.successfulDescriptionEdit'));
            this.setClubMember(secondResponse.data);
            this.previousDescription = this.description;
          });
        }
      });
    },
    ...mapMutations(['setClubMember']),
    modifyColor() {
      let editingData = {
        clubId: this.$store.state.clubMember.club.id,
        color: this.color,
      };

      Repository.modifyClubColor(editingData).then((response) => {
        if(response.status < 400) {
          Repository.getClubMember(this.$store.state.clubMember.id).then((secondResponse) => {
            alert(this.$t('notifications.successfulColorEdit'));
            this.setClubMember(secondResponse.data);
            this.previousColor = this.color;
          });
        }
      });
    },
    goToPlans() {
      this.$router.push('/subscription-plans-club');
    },
    goToSupport() {
      window.open("https://t.me/Swiset", '_blank');
    }
  }
}
</script>



<style scoped>
.button-plans {
  background-color: #111111 !important;
  color: #ffffff !important;
  border: #111111 solid 1px;
}
</style>
